import Avatar from '@material-ui/core/Avatar';
import { DateRange, Room, School } from '@material-ui/icons';
import { getTrainings } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarCompany from 'components/Avatar/AvatarCompany';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedMessage } from 'react-intl';

import theme from '../../../theme';

const {
  colors: { background, schoolNameColor },
} = theme;

const Education = ({ info }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const userid = info?.id;

  const { data: trainings = [] } = useQuery(getTrainings, {
    key: ['trainings', userid],
    variables: { id: userid },
    enabled: typeof userid !== 'undefined',
  });

  return (
    <div className={classes.container}>
      <div className={classes.editContainer}>
        <div className={cx(classes.title, global.title)}>
          <FormattedMessage id="student.profil.education.title" />
        </div>
      </div>
      {!trainings?.length ? (
        <div
          className={cx(css({
            textAlign: 'center',
            marginTop: spacing(2),
          }), global.infoText)}
        >
          <FormattedMessage id="noElements" />
        </div>
      ) : (
        trainings?.map(
          (
            {
              city,
              degree,
              endDate,
              label,
              school,
              schoolId,
              startDate,
              verified,
            },
            index
          ) => (
            <div key={index} className={classes.educationContainer}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                <div className={classes.photo}>
                  {schoolId ? (
                    <AvatarCompany
                      height={70}
                      idCompany={schoolId}
                      name={school}
                      variant="rounded"
                      width={70}
                    />
                  ) : (
                    <Avatar className={classes.avatar} variant="rounded">
                      {school?.substr(0, 1)}
                    </Avatar>
                  )}
                </div>
                <div className={classes.educationDescription}>
                  <div className={global.subTitle}>{label}</div>
                  <div style={{marginBottom: '8px'}} className={global.frac}>
                    <div className={global.title}>{school}</div>
                    {verified && <VerifiedIcon color="#1DA1F2" style={{width: '16px', height: '16px', marginLeft: '8px'}} />}
                  </div>
                  <div className={global.frac}>
                    <Room className={global.smallIcon} />
                    <div className={global.infoText}>
                      {city}
                    </div>
                  </div>
                  <div className={global.frac}>
                    <School className={global.smallIcon} />
                    <div className={global.infoText}>
                      {degree?.label?.includes('-')
                        ? degree?.label?.split(' ')[0]
                        : degree?.label}{' '}
                    </div>
                  </div>
                  <div className={global.frac}>
                    <DateRange className={global.smallIcon} />
                    <div className={global.infoText}>
                      <FormattedDate
                        day="numeric"
                        month="long"
                        value={startDate}
                        year="numeric"
                      />{' '}
                      {endDate ? (
                        <>
                          au{' '}
                          <FormattedDate
                            day="numeric"
                            month="long"
                            value={endDate}
                            year="numeric"
                          />
                        </>
                      ) : (
                        " - Aujourd'hui"
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        )
      )}
    </div>
  );
};

const styles = ({ spacing, fontSizes }) => ({
  container: {
    borderRadius: 10,
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
  },
  editContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    borderLeft: '3px solid #0060F9',
    lineHeight: '100%',
    paddingLeft: spacing(1),
    marginBottom: spacing(1.5),
  },
  avatar: {
    height: 70,
    width: 70,
  },
  educationDescription: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: spacing(2),
    fontFamily: 'Montserrat',
  },
  educationInfos: {
    display: 'flex',
    flexDirection: 'column',
  },
});

Education.propTypes = {
  info: PropTypes.object,
};

export default Education;
